import React, { useState } from 'react';

import { Box, Tab, Tabs } from '@mui/material';

import CostPerPointRatesPage from '~/components/Loyalty/CostPerPoint/CostPerPointRatesPage';
import { loyaltySubTabsContainerSx } from '~/components/Loyalty/loyaltyTabStyles';

import PartnersListPage from './PartnersListPage';

type PartnersSubTab = 'rate-cards' | 'partners';

/**
 * Partners page: groups Société Point partner management under a single top-level
 * loyalty tab — the existing CPP rate-cards workflow plus a read-only partner
 * directory — to reduce nav width.
 */
export default function PartnersPage() {
  const [tab, setTab] = useState<PartnersSubTab>('rate-cards');

  return (
    <Box>
      <Box sx={loyaltySubTabsContainerSx}>
        <Tabs value={tab} onChange={(_, next) => setTab(next as PartnersSubTab)}>
          <Tab value="rate-cards" label="Rate Cards" />
          <Tab value="partners" label="Partners" />
        </Tabs>
      </Box>

      {tab === 'rate-cards' ? <CostPerPointRatesPage /> : <PartnersListPage />}
    </Box>
  );
}
